import React, { useState } from 'react'
import { formatValue } from '../../helpers/funcs'
import Placeholder from '../misc/placeholder'

const ProjectListVertical = props => {

    const [expanded, setExpanded] = useState([])
    const { data, Subtitle } = props
    const toggleProject = (item) => {
        expanded.indexOf(item) > -1 ?
            setExpanded(expanded.filter(k => k !== item))
            : setExpanded([...expanded, item])
    }
    return data ? (
        <section className="section">
            <h3 className="section-header">{props.Title || 'List of AEs'}{props.Total && ` (${data ? data.length : 0})`}
                {Subtitle && (
                    <React.Fragment>
                        <br />
                        <small className="subtitle">{Subtitle}</small>
                    </React.Fragment>
                )}
            </h3>
            <hr />
            {data && data.length ? (
                <React.Fragment>
                    <p><strong>Total GCF Budget (USD)</strong>: {formatValue(data.reduce((acum, item) => {
                        return acum + item.TotalGCFBudgetUSD
                    }, 0))}</p>
                    <p><strong>Total Budget (USD):</strong> {formatValue(data.reduce((acum, item) => {
                        return acum + item.TotalBudgetUSD
                    }, 0))}</p>
                </React.Fragment>
            ) : null}
            {data && data.length > 0 ? (
                <ul className="projectListVertical">
                    {data.map(p => (
                        <li key={p.ProjectsID} className={expanded.indexOf(p.ProjectsID) > -1 ? 'active' : ''} onClick={() => toggleProject(p.ProjectsID)}>
                            <i className={`fas fa-caret-${expanded.indexOf(p.ProjectsID) > -1 ? 'down' : 'right'}`} />
                            {' '}
                            <strong>{p.ApprovedRef || p.ProjectsID}</strong> {p.ProjectName}
                            <div className="project-details">
                                <dl className="row no-gutters mt-2">
                                    <div className="col-3 col-sm-2">
                                        <dt>Entity(ies)</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{p.EntityList}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>Stage</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{(p.LatestStage || "").substr(3)}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>Theme</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{p.Theme}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>Sector</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{p.Sector}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>Region(s)</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{p.RegionList}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>Countries</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{p.CountryListDetails ? (JSON.parse(p.CountryListDetails)).map(c => (
                                            <img className="miniflag" key={c.ISO2} src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/24/${c.ISO2.toLowerCase()}.png`} alt={c.CountryName} title={c.CountryName} />
                                        )) : '-'}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>GCF Financing</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{formatValue(p.TotalGCFBudgetUSD)}</dd>
                                    </div>
                                    <div className="col-3 col-sm-2">
                                        <dt>Total Financing</dt>
                                    </div>
                                    <div className="col-9 col-sm-10">
                                        <dd>{formatValue(p.TotalBudgetUSD)}</dd>
                                    </div>
                                </dl>
                            </div>
                        </li>

                    ))}
                </ul>
            ) : <p>No projects for this contributor in this category.</p>}

        </section>
    ) : <Placeholder />
}

export default ProjectListVertical